// hooks/useAuthService.js
import { useAuth } from "../contexts/AuthContext";
import * as authService from "../api/authService";
import { useCallback } from "react";

const useAuthService = () => {
  const { updateToken, removeToken } = useAuth();

  const login = (email, password) => {
    return authService.login(email, password, updateToken);
  };

  const register = (email, password) => {
    return authService.register(email, password);
  };

  const refreshAccessToken = useCallback((navigate) => {
    return authService.refreshAccessToken(navigate, updateToken, removeToken);
  }, [removeToken, updateToken]);

  const checkRefreshToken = useCallback(() => {
    return authService.checkRefreshToken(updateToken, removeToken);
  }, [removeToken, updateToken]);

  const LogoutUser = (navigate) => {
    return authService.LogoutUser(navigate, removeToken);
  };

  return { login, register, refreshAccessToken, checkRefreshToken, LogoutUser };
};

export default useAuthService;